export const CREATE_DODO_PAYMENT_URL_REQUEST =
  "CREATE_DODO_PAYMENT_URL_REQUEST";
export const CREATE_DODO_PAYMENT_URL_SUCCESS =
  "CREATE_DODO_PAYMENT_URL_SUCCESS";
export const CREATE_DODO_PAYMENT_URL_FAILED = "CREATE_DODO_PAYMENT_URL_FAILED";
export const CREATE_DODO_PAYMENT_URL_RESET = "CREATE_DODO_PAYMENT_URL_RESET";

export const GET_PAYMENT_INFO_REQUEST = "GET_PAYMENT_INFO_REQUEST";
export const GET_PAYMENT_INFO_SUCCESS = "GET_PAYMENT_INFO_SUCCESS";
export const GET_PAYMENT_INFO_FAILED = "GET_PAYMENT_INFO_FAILED";
